import { render, staticRenderFns } from "./statisticsIconRight.vue?vue&type=template&id=c1fb50e6&"
import script from "./statisticsIconRight.vue?vue&type=script&lang=js&"
export * from "./statisticsIconRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports